export const publications = [
  {
    logo: "/assets/images/Logos/IEEE.png",
    title:
      "Leukemia Prediction from Microscopic Images of Human Blood Cell Using HOG Feature Descriptor and Logistic Regression",
    venue:
      "2018 16th International Conference on ICT and Knowledge Engineering (ICT&KE)",
    publisher: "IEEE",
    issued: "Jan 17, 2019",
    accent: "red",
    doi: "10.1109/ICTKE.2018.8612303",
    link: "https://doi.org/10.1109/ICTKE.2018.8612303",
  },
];